import '@angular/localize/init';
export * from './lib/feature-tax-uitstel-details.module';

export * from './lib/tax-uitstel-details/feature-tax-uitstel-details.component';
